import * as React from 'react';
import { actionRequiredService } from '@/api';
import { useNotification } from '@/hooks/useNotification';
import {
	FileType,
	UploadFile,
	UseDocumentationModalsParams,
	UseDocumentationModalsResult,
} from '@/interfaces';
import { formatErrorMessage } from '@/lib';
import {
	getDocumentModalType,
	getReviewSignStatus,
	isReviewSignDocument,
} from '@/utils/caseDocumentation';

export const useDocumentationModals = ({
	applicationId,
	refetch,
}: UseDocumentationModalsParams): UseDocumentationModalsResult => {
	const { toastSuccess, toastError } = useNotification();
	const [isClaimFormOpen, setIsClaimFormOpen] = React.useState<boolean>(false);
	const [isModalFollowUpOpen, setIsModalFollowUpOpen] = React.useState(false);
	const [isModalAcceptOpt, setIsModalAcceptOpt] = React.useState(false);
	const [isModalReviewSignOpen, setIsModalReviewSignOpen] =
		React.useState(false);
	const [isModalRetainerOpen, setIsModalRetainerOpen] = React.useState(false);
	const [isModalFollowSurveyOpen, setIsModalFollowSurveyOpen] =
		React.useState(false);
	const [documentationSelected, setDocumentationSelected] =
		React.useState<FileType>();

	const handleUploadFile = async (file: File): Promise<void> => {
		if (applicationId) {
			try {
				const data: UploadFile = {
					applicationId: applicationId,
					doc: file,
					fileName: file.name,
				};
				await actionRequiredService.postUploadFile(data);
				refetch();
				toastSuccess('You successfully uploaded your file.');
			} catch (error) {
				toastError(formatErrorMessage((error as any).message));
			}
		}
	};

	const handleOnClickModal = (record: FileType): void => {
		const { isReviewSign, isRetainer, isFollowUpDocument } =
			getDocumentModalType(record);
		setDocumentationSelected(record);

		if (record.file_name === 'Claim Form') {
			setIsClaimFormOpen(true);
		} else if (record.file_name?.includes('Response to Question')) {
			setIsModalFollowUpOpen(true);
		} else if (record.file_name === 'Opt') {
			setIsModalAcceptOpt(true);
		} else if (isReviewSign) {
			setIsModalReviewSignOpen(true);
		} else if (isRetainer) {
			setIsModalRetainerOpen(true);
		} else if (isFollowUpDocument) {
			setIsModalFollowSurveyOpen(true);
		}
	};

	const isDocumentReviewSign = documentationSelected
		? !!isReviewSignDocument(documentationSelected)
		: false;
	const documentStatus = getReviewSignStatus(documentationSelected);

	return {
		documentationSelected,
		isClaimFormOpen,
		setIsClaimFormOpen,
		isModalFollowUpOpen,
		setIsModalFollowUpOpen,
		isModalAcceptOpt,
		setIsModalAcceptOpt,
		isModalReviewSignOpen,
		setIsModalReviewSignOpen,
		isModalRetainerOpen,
		setIsModalRetainerOpen,
		isModalFollowSurveyOpen,
		setIsModalFollowSurveyOpen,
		isDocumentReviewSign,
		documentStatus,
		handleOnClickModal,
		handleUploadFile,
	};
};
